import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar } from '@material-ui/core';
import { useRouteMatch } from 'react-router';
import clsx from 'clsx';
import { CheckIcon, TimesIcon } from '../icon/solid';
import FormReset from '../form-reset/ReactFormReset';
import useStyles from './styles';
import { setAllowChangeProjectStatus } from '../../store/modules/projects/actions';
import { useDispatch } from 'react-redux';
import ReactFormSubmit from '../form-submit/ReactFormSubmit';

export const CONTROLS_CONTAINER_HEIGHT = 72;

type Props = {
  preventCancelChanges: boolean;
  dirty: boolean;
  loading: boolean;
  submitButtonText: string;
  position?: 'fixed' | 'absolute' | 'sticky' | 'static' | 'relative';
};

const ItemFormControlsReact = ({
  preventCancelChanges,
  dirty,
  loading,
  position = 'fixed',
  submitButtonText,
}: Props) => {
  const classes = useStyles();
  const { path } = useRouteMatch();
  const videoMenuRoute = 'dashboard/admin/video-menus';
  const [useCustomPadding, setUseCustomPadding] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setAllowChangeProjectStatus(!dirty));

    return () => {
      dispatch(setAllowChangeProjectStatus(true));
    };
  }, [dispatch, dirty]);

  useEffect(() => {
    if (path.indexOf(videoMenuRoute) > -1) {
      setUseCustomPadding(true);
    } else {
      setUseCustomPadding(false);
    }
  }, [path, videoMenuRoute, setUseCustomPadding]);

  return (
    <div style={{ height: CONTROLS_CONTAINER_HEIGHT }} >
      <AppBar
        position={position}
        className={clsx(classes.panel, {
          [classes.panelFixed]: position !== 'relative',
          [classes.panelForVideoMenu]: (useCustomPadding),
        })}
      >
        <Toolbar className={classes.toolbar}>
          <ReactFormSubmit
            className={classes.panelButton}
            variant="contained"
            color="primary"
            disabled={loading}
            data-intercom-target="Save button"
          >
            <CheckIcon className={classes.buttonIcon} />
            <span className={classes.buttonText}>{submitButtonText}</span>
          </ReactFormSubmit>
          <FormReset
            preventCancelChanges={dirty && preventCancelChanges}
            className={clsx(classes.cancelButton, classes.panelButton)}
            variant="contained"
            color="default"
            withHotkey
            data-intercom-target="Cancel button"
          >
            <TimesIcon className={classes.buttonIcon} />
            <span className={classes.buttonText}>Cancel</span>
          </FormReset>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default ItemFormControlsReact;
